module.exports = "/dist/montserrat-latin-900italic.svg?7be6a85fe946f113dc84f0e3692cafdd";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-900italic.svg
// module id = 83
// module chunks = 0